import { google } from '@unite-us/client-utils';

import { env } from 'src/config/env';

const { googleMapsScriptUrl } = google;

const requiredMapScript = {
  scripts: [googleMapsScriptUrl({ key: env.GOOGLE_MAPS_API_KEY })],
};

export default requiredMapScript;
